import {Injectable} from '@angular/core';
import {MedicalMorphologyModel} from '../model/medicalMorphology.model';
import {MedicalMorphologyRepository} from '../../impl/service/ngrx/medicalMorphology.repository';
import {MedicalMorphologyDataServiceAdapter} from '../../impl/service/ngrx/medicalMorphologyDataService.adapter';
import {AbstractDeleteOneService} from '../../../../core/service/v2/service/delete/abstractDeleteOne.service';
@Injectable()
export class MedicalMorphologyDeleteService
    extends AbstractDeleteOneService<MedicalMorphologyModel, MedicalMorphologyModel> {

    constructor(repository: MedicalMorphologyRepository, dataServiceAdapter: MedicalMorphologyDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
